import { Box, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { BackButton } from '../components/BackButton'
import ContactCard from '../components/ContactCard'
import { PageContainer } from '../components/layout/PageContainer'
import YesNoAction from '../components/YesNoAction'
import {
  selectAllFarmerAccounts,
  selectContactInfo,
  selectCurrentFarmerAccount,
} from '../features/azure-b2c/storage'
import { TestIds } from '../testIds'

export const EnquiryRequestSent = () => {
  const farmlandsAccounts = useSelector(selectAllFarmerAccounts)
  const currentAccount = useSelector(selectCurrentFarmerAccount)
  const navigate = useNavigate()

  const relationshipOwner = useSelector(selectContactInfo)

  const cartOrMessage = React.useMemo(() => {
    return (
      <>
        <YesNoAction
          display='Enquiry Request Sent'
          subheading={
            <Typography variant='h4' sx={{ mt: 4, mb: 2 }}>
              Thanks {farmlandsAccounts?.contactFirstName}!
            </Typography>
          }
          body={
            <Typography variant='body2'>
              Your request has been sent to your Farmlands representative{' '}
              {relationshipOwner?.fullName} to review. They will contact you directly to inform you
              when this item will be back in stock.
            </Typography>
          }
        />
        <Box mt={4} />
        <ContactCard
          sx={{ mt: 4 }}
          title='If you have any questions please contact your Farmlands representative.'
          data-testid={TestIds.components.contactCard.card}
          {...relationshipOwner}
        />
      </>
    )
  }, [currentAccount])

  return (
    <PageContainer data-testid={TestIds.pages.cart}>
      <BackButton text='Products' onClick={() => navigate('/products')} />
      {cartOrMessage}
    </PageContainer>
  )
}
